import { ReactNode } from 'react'
import * as styles from './input-group.css'

interface InputGroupProps {
  /** The child elements to be rendered with consistent spacing */
  children: ReactNode
  /** Optional title for the input group */
  title?: string
}

export function InputGroup({ children, title }: InputGroupProps) {
  return (
    <div className={styles.inputGroup}>
      {title && <span className={styles.title}>{title}</span>}
      {children}
    </div>
  )
}
